module.exports = __webpack_public_path__ + "static/aktualne-wymiary-grafik-na-facebooku_og-8d7e99e7bc03887642a39ed8b145dd8e.png";